var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCarbonIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 36 36"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#A4ADB4",
  d: "M33.75 12.375v-6.75H27v2.25H15.75V4.5a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 4.5v9a2.25 2.25 0 0 0 2.25 2.25h9a2.25 2.25 0 0 0 2.25-2.25v-3.375a3.38 3.38 0 0 1 3.375 3.375v10.125h-6.75v-2.25h-6.75v6.75h6.75v-2.25h6.75v2.25a2.25 2.25 0 0 0 2.25 2.25H27v2.25h6.75v-6.75H27v2.25h-5.625V20.25H27v2.25h6.75v-6.75H27V18h-5.625v-4.5a5.57 5.57 0 0 0-1.153-3.375H27v2.25zM4.5 13.5v-9h9v9zm5.625 12.375h-2.25v-2.25h2.25zm19.125 2.25h2.25v2.25h-2.25zm0-10.125h2.25v2.25h-2.25zm0-10.125h2.25v2.25h-2.25z"
})));
export default SvgCarbonIcon;